export default __webpack_public_path__ + "static/media/DodgeBG.ca83e016.png";